// forms.js

import React, { Component } from 'react';
import {
  Button,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  HelpBlock,
  Modal
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { update_user } from '../../utils/apputils';
import { users } from '../../store/actions';
import { changePassword } from '../../utils/apputils';
import logo from '../../static/images/logo-countpicula-dark.png';
import Spinner from '../Spinner/Spinner.js';
import { passwordMinLength } from '../../utils/user_config';

const button_state = status => {
  let stuff = {
    unchanged: {
      disabled: true,
      icon: 'saved'
    },
    edited: {
      disabled: false,
      icon: 'save'
    },
    saved: {
      disabled: true,
      icon: 'saved'
    }
  };
  return stuff[[status]];
};

class ProfileForm_Class extends Component {
  // Lots of stuff here because we're a form, and that's allowed.
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.changePassword = this.changePassword.bind(this);
    const { given_name, email } = this.props;
    this.state = {
      given_name,
      email,
      original_given_name: given_name,
      original_email: email,
      status: 'unchanged'
    };
  }

  componentWillReceiveProps({ given_name, email }) {
    this.setState({
      given_name,
      email,
      original_given_name: given_name,
      original_email: email,
      status: 'unchanged'
    });
  }

  onChange({ target: { value: val, id } }) {
    if (val === this.state[`original_${id}`]) {
      this.setState({ [id]: val, status: 'unchanged' });
      return;
    }
    this.setState({
      [id]: val,
      status: 'edited'
    });
  }

  onSubmit(e) {
    e.preventDefault();
    const { dispatch, user } = this.props;
    const { email, given_name } = this.state;
    let attrs = {
      email,
      given_name
    };
    update_user(user, attrs, dispatch);
    this.setState({
      original_email: email,
      original_given_name: given_name,
      status: 'saved'
    });
  }

  changePassword(e) {
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch(users.prompting_change_password());
  }

  render() {
    const { status, given_name, email } = this.state;
    let parms = button_state(status);
    return (
      <Form onSubmit={this.onSubmit} horizontal>
        <FormGroup controlId="given_name">
          <Col sm={2} componentClass={ControlLabel}>
            Name
          </Col>
          <Col sm={9}>
            <FormControl
              type="text"
              value={given_name}
              placeholder="What should we call you?"
              onChange={this.onChange}
              required
            />
            <FormControl.Feedback />
            <HelpBlock>
              This is the name we&rsquo;ll use when communicating with you
              around the site and in emails.
            </HelpBlock>
          </Col>
        </FormGroup>
        <FormGroup controlId="email">
          <Col sm={2} componentClass={ControlLabel}>
            Email address
          </Col>
          <Col sm={9}>
            <FormControl
              type="email"
              value={email}
              placeholder="example@example.com"
              onChange={this.onChange}
              required
            />
            <FormControl.Feedback />
            <HelpBlock>
              We&rsquo;ll use your email as your sign in. It&rsquo;s also how
              you&rsquo;ll recover any lost passwords.
            </HelpBlock>
          </Col>
        </FormGroup>
        <FormGroup>
          <Col smOffset={2} sm={9}>
            <Button bsStyle="primary" type="submit" disabled={parms.disabled}>
              Save changes&nbsp;
              <span className={`glyphicon glyphicon-${parms.icon}`} />
            </Button>
          </Col>
        </FormGroup>
        <FormGroup>
          <Col smOffset={2} sm={9}>
            <Button
              bsStyle="primary"
              type="button"
              onClick={this.changePassword}
            >
              Change password <span className="glyphicon glyphicon-pencil" />
            </Button>
          </Col>
        </FormGroup>
      </Form>
    );
  }
}
const profileformStateToProps = state => ({
  user: state.users.user,
  given_name: state.users.given_name,
  email: state.users.email,
  status: state.users.status
});
export const ProfileForm = connect(profileformStateToProps)(ProfileForm_Class);

const changePasswordStateToProps = state => ({
  status: state.users.status,
  error: state.users.error
});

class ChangePasswordForm_Class extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {
      oldPassword: '',
      newPassword: '',
      oldPasswordValid: false,
      newPasswordValid: false
    };
  }

  onChange({ target: { id, value } }) {
    if (id === 'oldPassword') {
      const valid = value.length > passwordMinLength;
      this.setState({ oldPasswordValid: valid });
    }
    if (id === 'newPassword') {
      const valid = value.length > passwordMinLength;
      this.setState({ newPasswordValid: valid });
    }
    this.setState({
      [id]: value
    });
  }

  cancel() {
    const { dispatch } = this.props;
    dispatch(users.got_details());
  }

  onSubmit(e) {
    e.preventDefault();
    const { dispatch } = this.props;
    const { oldPassword, newPassword } = this.state;
    changePassword(oldPassword, newPassword, dispatch);
  }

  getValidationState(field) {
    const { oldPassword, newPassword } = this.state;
    let length = 0;
    if (field === 'oldPassword') {
      length = oldPassword.length;
    } else if (field === 'newPassword') {
      length = newPassword.length;
    }
    if (length > passwordMinLength) {
      return 'success';
    } else if (length > 0) {
      return 'error';
    }
    return null;
  }

  render() {
    const {
      oldPassword,
      newPassword,
      oldPasswordValid,
      newPasswordValid
    } = this.state;
    const { status, error } = this.props;
    return (
      <form onSubmit={this.onSubmit}>
        <FormGroup
          validationState={this.getValidationState('oldPassword')}
          controlId="oldPassword"
        >
          <FormControl
            type="password"
            value={oldPassword}
            placeholder="Current password"
            onChange={this.onChange}
            required
          />
        </FormGroup>
        <FormGroup
          validationState={this.getValidationState('newPassword')}
          controlId="newPassword"
        >
          <FormControl
            type="password"
            value={newPassword}
            placeholder="New password"
            onChange={this.onChange}
            required
          />
          <HelpBlock className="help-block-black">
            Password must contain more than {passwordMinLength} characters.
          </HelpBlock>
        </FormGroup>

        {status === users.types.PROMPTING_CHANGE_PASSWORD && (
          <span>
            <Button onClick={this.cancel}>Cancel</Button>
            <Button
              bsStyle="primary"
              className="pull-right"
              type="submit"
              disabled={!(oldPasswordValid && newPasswordValid)}
            >
              Set
            </Button>
          </span>
        )}
        {status === users.types.CHANGE_PASSWORD_FAILED && (
          <span>
            <span className="error">{error}</span>
            <br />
            <Button onClick={this.cancel}>Cancel</Button>
            <Button
              bsStyle="primary"
              className="pull-right"
              type="submit"
              disabled={!(oldPasswordValid && newPasswordValid)}
            >
              Set
            </Button>
          </span>
        )}
        {status === users.types.CHANGING_PASSWORD && <Spinner type="regular" />}
      </form>
    );
  }
}
const ChangePasswordForm = connect(changePasswordStateToProps)(
  ChangePasswordForm_Class
);

class ChangePassword_Class extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    const { dispatch } = this.props;
    dispatch(users.got_details());
  }

  render() {
    const { status } = this.props;
    const show = [
      users.types.PROMPTING_CHANGE_PASSWORD,
      users.types.CHANGING_PASSWORD,
      users.types.CHANGE_PASSWORD_FAILED
    ].includes(status);

    return (
      <React.Fragment>
        <Modal show={show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <h2 className="modal-title" id="m_registerLabel">
              <span>Password reset</span>
            </h2>
            <img
              className="logo-img"
              src={logo}
              width="117"
              height="75"
              alt=""
            />
          </Modal.Header>
          <Modal.Body>
            <ChangePasswordForm close={this.handleClose} />
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

export const ChangePassword = connect(changePasswordStateToProps)(
  ChangePassword_Class
);



// WEBPACK FOOTER //
// ./src/comps/Profile/Forms.js